/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dx-error-message[_ngcontent-%COMP%]{min-height:60px;max-height:600px;overflow-y:auto}\n/*# sourceMappingURL=dx-error-modal.component.css.map*/"];
export { styles as styles };
